<template>
  <div>
    <div class="d-flex mb-3 align-items-end">
      <h1 class="h4 primary--text">
        {{ $t('views.complaints_report.complaints_report') }}
      </h1>
      <div class="ml-auto">
        <v-btn
          outlined
          large
          @click="toggleFilter"
        >
          <v-icon left>
            mdi-filter-variant
          </v-icon>
          {{ $t('common.filter') }}
        </v-btn>
      </div>
    </div>
    <complaints-report-filter
      v-model="isFilterShown"
      :filter="filter"
      @applyFilter="applyFilter"
    />
    <v-data-table
      fixed-header
      :headers="headers"
      :items="items"
      :footer-props="{
        itemsPerPageOptions: [10, 20, 50, 100],
      }"
      :options.sync="options"
      :server-items-length="total"
      :loading="loading"
      :loading-text="$t('common.loading_data')"
    />
  </div>
</template>

<script>
import ComplaintsReportFilter from '@/components/reports/ComplaintsReportFilter';

export default {
  name: 'ComplaintsReport',

  components: {
    ComplaintsReportFilter,
  },

  data() {
    return {
      items: [],
      options: {
        page: 1,
      },
      total: 0,
      loading: false,

      headers: [
        { text: this.$t('common.placement_date'), value: 'complaintDate' },
        { text: this.$t('views.complaints_report.complaint_number'), value: 'complaintNumber' },
        { text: this.$t('common.orders.complaint_code'), value: 'complaintCode' },
        { text: this.$t('common.status'), value: 'status' },
        { text: this.$t('common.order_sum_with_vat'), value: 'totalWithVAT' },
        { text: this.$t('views.complaints_report.sender'), value: 'sender' },
      ],

      filter: {
        startDate: '',
        endDate: '',
        complaintNumber: '',
        status: '',
        totalWithVAT: null,
        sender: '',
      },
      isFilterShown: false,
    };
  },

  watch: {
    options: {
      handler() {
        this.getItems();
      },
      deep: true,
    },
  },

  methods: {
    async getItems() {
      this.loading = true;

      const {
        sortBy, sortDesc, page, itemsPerPage,
      } = this.options;

      const filter = this.mapFilter();

      const params = {
        query: filter,
        pageSize: itemsPerPage,
        page,
      };

      if (sortBy.length) {
        params.sort = `${sortDesc[0] ? '-' : ''}${sortBy[0]}`;
      }

      try {
        const { data } = await this.$http.get('complaints-report', { params });
        this.items = data.rows.map((item) => ({
          ...item,
          complaintDate: this.$moment(item.complaintDate).format('L LT'),
          status: this.$t(`enums.complaint_statuses.${item.status.toLowerCase()}`),
        }));
        this.total = data.total;
      } finally {
        this.loading = false;
      }
    },

    toggleFilter() {
      this.isFilterShown = !this.isFilterShown;
    },

    applyFilter(filter) {
      this.filter = { ...filter };
      this.options.page = 1;
      this.getItems();
    },

    mapFilter() {
      const filter = {};

      if (this.filter.startDate || this.filter.endDate) {
        filter.complaintDate = {};
      }
      if (this.filter.startDate) {
        filter.complaintDate.$gte = this.$moment(this.filter.startDate, 'L');
      }
      if (this.filter.endDate) {
        filter.complaintDate.$lte = this.$moment(this.filter.endDate, 'L').endOf('day');
      }

      if (this.filter.complaintNumber) {
        filter.complaintNumber = {
          $regex: `.*${this.filter.complaintNumber}.*`,
          $options: 'i',
        };
      }
      if (this.filter.status) {
        filter.status = this.filter.status;
      }
      if (typeof this.filter.totalWithVAT === 'number') {
        filter.totalWithVAT = this.filter.totalWithVAT;
      }
      if (this.filter.sender) {
        filter.sender = {
          $regex: `.*${this.filter.sender}.*`,
          $options: 'i',
        };
      }

      return filter;
    },
  },
};
</script>
